export class FuelRequest {
    id?: string
    dateTime: Date | null = new Date()
    job = ''
    operatorName: number = 0
    equipmentNumber = ''
    currentFuelLevel = ''
    fuelTypeRequired = ''
    isEquipmentRunning = ''
    priorityLevel = ''
    additionalNotes = ''
}
